export default __webpack_public_path__ + "static/media/rupee.eb107417.svg";